import React, { Component } from 'react'
import { Button, Modal } from 'hljd'
import UnionTable from './UnionTable'
import TableStore from '../Table/store'
import { PUBLISH_CASE_PATH_A } from '@constant'

class Operator extends Component {
  state = {
    visible: false,
    selectData: []
  }
  newPhoto = () => {
    window.open(PUBLISH_CASE_PATH_A)
  }

  showModal = () => {
    this.setState({ visible: true })
  }

  onOk = () => {
    this.setState({ visible: false })
    this.props.store.addRelation(this.state.selectData, () => {
      TableStore.$getList(1)
    })
  }

  onCancle = () => {
    this.setState({ visible: false })
  }

  selectChange = selectData => {
    this.setState({ selectData })
  }

  render() {
    const { visible, selectData } = this.state
    const { store } = this.props
    const ids = TableStore.ids
    return (
      <div className="operator-wrap clearfix" id="operator-wrap">
        <span className="title">所关联客照列表</span>
        <div className="fr">
          <Button type="default" className="new-btn" onClick={this.newPhoto}>
            发布新客照
          </Button>
          <Button onClick={this.showModal} type="primary" className="union-btn">
            关联已有客照
          </Button>
        </div>
        <Modal
          title="关联客照"
          visible={visible}
          onOk={this.onOk}
          onCancel={this.onCancle}
          width={800}
          wrapClassName="unoin-table"
        >
          <UnionTable
            selectedRowKeys={selectData}
            ids={ids}
            id={store.id}
            selectChange={this.selectChange}
          />
        </Modal>
      </div>
    )
  }
}

export default Operator
